/* eslint-disable complexity */
const {
    SUBMITTED_ORDER,
    TOGGLE_PLACE_ORDER,
    UPDATE_DELIVERY_INSTRUCTIONS,
    UPDATE_ORDER_GIFT_WRAP_OPTIONS,
    UPDATE_ORDER,
    UPDATE_SHIPPING_METHODS,
    VALIDATE_ADDRESS,
    CREATE_DRAFT_HAL_ADDRESS,
    SHOW_SCHEDULED_DELIVERY_UNAVAILABLE,
    REMOVE_HAL_ADDRESS,
    UPDATE_CURRENT_HAL_ADDRESS,
    UPDATE_ADDRESS_LIST_WITH_HAL_ADDRESS,
    UPDATE_SEPHORA_TERMS,
    UPDATE_AUTOREPLENISH_TERMS
} = require('../constants/actionTypes/order');
const {
    SHIPPING_GROUPS: {
        HARD_GOOD,
        SAME_DAY
    },
    SHIPPING_METHOD_TYPES: {
        HAL
    },
    whatDefaultAddressAfterHal
} = require('../utils/Order');


const initialState = {
    orderDetails: {
        isInitialized: false,
        header: { profile: { user: {} } },
        items: { items: [] },
        priceInfo: {},
        shippingGroups: { shippingGroupsEntries: [] },
        paymentGroups: { paymentGroupsEntries: [] }
    },
    editOrderData: {},
    giftWrapOptions: {},
    orderShippingMethods: {},
    addressList: [],
    halAddress: null,
    halOperatingHours: [],
    paymentOptions: {},
    isApplePayFlow: false,
    acceptSephoraTerms: false,
    acceptAutoReplenishTerms: false
};

/**
 * If removing property from basket state, don't remove property entirely.
 * If you do, state will not reflect change due to object.assign.
 * Instead set property value to null to simulate removal, this will update state.
 */

const reducer = function (state = initialState, action) {
    const {
        type, payload
    } = action;

    switch (type) {
        case UPDATE_ORDER: {
            const { orderDetails = {} } = action;

            return Object.assign({}, state, {
                orderDetails: Object.assign(
                    {},
                    orderDetails,
                    { isInitialized: state.orderDetails.isInitialized || orderDetails.isInitialized }
                )
            });
        }
        case SUBMITTED_ORDER: {
            return Object.assign({}, state, { submittedDetails: action.submittedDetails });
        }
        case TOGGLE_PLACE_ORDER: {
            return Object.assign({}, state, { isPlaceOrderDisabled: action.isPlaceOrderDisabled });
        }
        case UPDATE_DELIVERY_INSTRUCTIONS: {
            const { deliveryInstructions } = payload;
            const {
                orderDetails,
                orderDetails: {
                    shippingGroups,
                    shippingGroups: { shippingGroupsEntries }
                }
            } = state;

            return {
                ...state,
                orderDetails: {
                    ...orderDetails,
                    shippingGroups: {
                        ...shippingGroups,
                        shippingGroupsEntries: shippingGroupsEntries.map(shippingGroup => {
                            if (shippingGroup.shippingGroupType === SAME_DAY) {
                                return {
                                    ...shippingGroup,
                                    shippingGroup: {
                                        ...shippingGroup.shippingGroup,
                                        deliveryInstructions
                                    }
                                };
                            } else {
                                return shippingGroup;
                            }
                        })
                    }
                }
            };
        }
        case UPDATE_ORDER_GIFT_WRAP_OPTIONS: {
            const {
                giftWrapId, giftMessage
            } = payload;
            const {
                orderDetails,
                orderDetails: {
                    shippingGroups,
                    shippingGroups: { shippingGroupsEntries }
                },
                giftWrapOptions = []
            } = state;
            const newGiftWrap = giftWrapOptions.find(giftWrap => giftWrap.giftWrapId === giftWrapId);

            return {
                ...state,
                orderDetails: {
                    ...orderDetails,
                    shippingGroups: {
                        ...shippingGroups,
                        shippingGroupsEntries: shippingGroupsEntries.map(shippingGroup => {
                            if (shippingGroup.shippingGroupType === HARD_GOOD) {
                                return {
                                    ...shippingGroup,
                                    shippingGroup: {
                                        ...shippingGroup.shippingGroup,
                                        giftOptions: {
                                            ...shippingGroup.shippingGroup?.giftOptions,
                                            giftMessage,
                                            giftWraps: [newGiftWrap]
                                        }
                                    }
                                };
                            } else {
                                return shippingGroup;
                            }
                        })
                    }
                }
            };
        }
        case UPDATE_SHIPPING_METHODS: {
            const orderShippingMethods = Object.assign({}, state.orderShippingMethods);
            orderShippingMethods[action.shippingGroup] = action.shippingMethods;

            return Object.assign({}, state, { orderShippingMethods: orderShippingMethods });
        }
        case VALIDATE_ADDRESS: {
            return Object.assign({}, state, { addressData: action.addressId });
        }
        case CREATE_DRAFT_HAL_ADDRESS: {
            const {
                orderDetails,
                orderDetails: {
                    shippingGroups,
                    shippingGroups: { shippingGroupsEntries }
                }
            } = state;

            const newShippingGroupsEntries = [...shippingGroupsEntries] || [];
            const addressIdx = newShippingGroupsEntries.findIndex(entry => entry.shippingGroup.shippingGroupId === action.shippingGroupId);

            let nextState = state;

            if (addressIdx >= 0) {
                const address = newShippingGroupsEntries[addressIdx].shippingGroup.address;
                newShippingGroupsEntries[addressIdx].shippingGroup.address = {
                    ...(address?.altPickLocationID) && address,
                    ...action.address,
                    addressId: null,
                    isDraft: true
                };

                nextState = {
                    ...state,
                    orderDetails: {
                        ...orderDetails,
                        shippingGroups: {
                            ...shippingGroups,
                            shippingGroupsEntries: newShippingGroupsEntries
                        }
                    },
                    halOperatingHours: action?.halOperatingHours
                };
            }

            return nextState;
        }
        case REMOVE_HAL_ADDRESS: {
            const {
                orderDetails,
                orderDetails: {
                    header: {
                        isGuestOrder
                    },
                    shippingGroups,
                    shippingGroups: { shippingGroupsEntries }
                }
            } = state;

            const newShippingGroupsEntries = [...shippingGroupsEntries] || [];
            const addressIdx = newShippingGroupsEntries.findIndex(entry => entry.shippingGroup.address.addressType === HAL);

            let nextState = state;

            if (addressIdx >= 0) {
                newShippingGroupsEntries[addressIdx].shippingGroup.address = whatDefaultAddressAfterHal(isGuestOrder);
                newShippingGroupsEntries[addressIdx].shippingGroup.isComplete = false;

                nextState = {
                    ...state,
                    orderDetails: {
                        ...orderDetails,
                        shippingGroups: {
                            ...shippingGroups,
                            shippingGroupsEntries: newShippingGroupsEntries
                        }
                    },
                    halOperatingHours: []
                };
            }

            return nextState;
        }
        case UPDATE_CURRENT_HAL_ADDRESS: {
            const { halAddress } = payload;

            return {
                ... state,
                halAddress
            };
        }
        case UPDATE_ADDRESS_LIST_WITH_HAL_ADDRESS: {
            const {
                addressList,
                halAddress
            } = state;
            let nextState = state;

            if (halAddress !== null) {
                nextState = {
                    ...state,
                    addressList: [halAddress, ... addressList]
                };
            }

            return nextState;
        }
        case UPDATE_SEPHORA_TERMS: {
            return {
                ... state,
                acceptSephoraTerms: action.payload.acceptSephoraTerms
            };
        }
        case UPDATE_AUTOREPLENISH_TERMS: {
            return {
                ...state,
                acceptAutoReplenishTerms: action.payload.acceptAutoReplenishTerms
            };
        }
        case SHOW_SCHEDULED_DELIVERY_UNAVAILABLE: {
            const { message } = payload;
            return Object.assign({}, state, { scheduledAddrChangeMessage: message });
        }
        default: {
            return state;
        }
    }
};

module.exports = reducer;
